


































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import {
  LanguageDto,
  ActivityDto,
  ActivityAreaDto,
  ActivityTypeDto,
  ActivityPriorityDto,
  UserDto,
  AppGroupDto,
  MetadataConfigurationComposer,
  MetadataConfiguration
} from "@/server/app.dtos";
import { ActivitiesService } from "@/services/api/activities.service";
import ConfigsService from "@/services/api/configs.service";
import { UsersService } from "@/services/api/users.service";
import {
  EditActivityCommand,
  EditActivityMetadataCommand
} from "@/server/app.commands";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import { GetActivityMetadataDtoQuery } from "@/server/app.queries";

@Component
export default class ActivityEditPage extends Vue {
  @Prop() activity!: ActivityDto;
  @Getter("currentLanguage") currentLanguage!: LanguageDto;
  instance!: EditActivityCommand;
  activitiesService: ActivitiesService = new ActivitiesService();
  usersService: UsersService = new UsersService();
  configsService: ConfigsService = new ConfigsService();
  activityTypes: ActivityTypeDto[] = [];
  activityPriorities: ActivityPriorityDto[] = [];
  users: UserDto[] | null = null;
  appGroups: AppGroupDto[] | null = null;
  metadata: MetadataConfiguration | null = null;

  tabs: string[] = ["Dados Gerais", "Atributos"];
  currentTab: string = "general";
  isLoading: boolean = false;
  isValid: boolean = false;

  start: Date = new Date();

  get area(): ActivityAreaDto | undefined {
    return this.activity?.activityArea;
  }

  async created() {
    this.instance = new EditActivityCommand();
    this.instance.init(this.activity);
    this.instance.appGroups = this.activity?.appGroups?.map(
      f => f.idAppGroup
    ) as number[];
    this.instance.idOwner = this.activity.owner?.idUser;
    await this.LoadRelatedData();
  }

  async LoadRelatedData() {
    let query: string = "IdLanguage=" + this.currentLanguage.idLanguage;
    if (this.area != null) {
      query += "&IdActivityArea=" + this.area.idActivityArea;
    }

    // Load App Groups
    await this.configsService.Load("api/appgroups", query).then(result => {
      this.appGroups = result;
    });

    // Load ActivityTypes
    await this.configsService.Load("api/activitytypes", query).then(result => {
      this.activityTypes = result;
    });

    // Load ActivityPriorities
    await this.configsService
      .Load(
        "api/activitypriorities",
        "IdLanguage=" + this.currentLanguage.idLanguage
      )
      .then(result => {
        this.activityPriorities = result;
      });

    // Load Users
    await this.usersService
      .GetInternalUsers(this.currentLanguage)
      .then((users: UserDto[]) => (this.users = users));

    // Load Metadata
    const metadataQuery = new GetActivityMetadataDtoQuery();
    metadataQuery.idActivity = this.activity.idActivity;
    metadataQuery.idLanguage = this.currentLanguage.idLanguage;
    await this.activitiesService
      .GetMetadata(metadataQuery)
      .then((response: MetadataConfiguration) => (this.metadata = response));
  }

  async onEditActivity() {
    if (this.isLoading) return;
    this.isLoading = true;
    await this.activitiesService
      .Edit(this.instance)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/activity/${id}/dashboard`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }

  async onEditMetatada(data: MetadataConfigurationComposer) {
    if (this.isLoading) return;
    this.isLoading = true;
    const command = new EditActivityMetadataCommand();
    command.idActivity = this.activity.idActivity;
    command.metadata = data.metadata;
    await this.activitiesService
      .EditMetadata(command)
      .then((id: number) => {
        NotificationServiceBus.showSuccessMessage(
          "Sucesso",
          "Operação efetuada com sucessso"
        );
        this.$router.push(`/activity/${id}/dashboard`);
      })
      .catch((error: any) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }
}
